import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getAccessTokenSession } from "../../utility/common/session-store";
import {
  removeAllInstance,
  removeSingleInstance,
  updateActiveInstances,
  setInstanceCompleted,
} from "../../features/instanceStatus/instanceStatusSlice";
import { getInstanceDetail } from "../../server/Instances";

const InstanceStatus: React.FC = () => {
  const userState = useAppSelector((state: any) => state.user);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let socket: WebSocket | null = null;

    try {
      const token = getAccessTokenSession();
      socket = new WebSocket(
        `${process.env.REACT_APP_WEBSOCKET_BASE_URL}event-stream/user`,
        [token]
      );

      if (userState !== undefined) {
        socket.onopen = () => {
          console.log("WebSocket connected");
        };

        socket.onmessage = async (event: MessageEvent) => {
          try {
            const messageData = JSON.parse(event.data);
            const { instance_id, message, status } = messageData.data;

            if (status === "success" || status === "completed") {
              try {
                const res = await getInstanceDetail(String(instance_id));
                const detail = res?.data?.instance;
                dispatch(setInstanceCompleted({ instance_id, detail }));
              } catch (detailErr) {
                console.error(
                  "Failed to get instance detail after completed:",
                  detailErr
                );
                dispatch(removeSingleInstance(instance_id));
              }
            } else {
              dispatch(updateActiveInstances({ instance_id, message, status }));
            }
          } catch (err) {
            console.error("Error parsing WebSocket message:", err);
          }
        };

        socket.onclose = () => {
          console.log("WebSocket disconnected");
          dispatch(removeAllInstance());
        };

        socket.onerror = (error) => {
          console.error("WebSocket error:", error);
        };
      }
    } catch (err) {
      console.warn("WebSocket not initialized due to missing token:", err);
      // Optional: redirect to login or show error
    }

    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, [userState, dispatch]);

  return <div></div>;
};

export default InstanceStatus;
